import script from "./InvoicingView.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvoicingView.vue?vue&type=script&setup=true&lang=ts"

import "./InvoicingView.vue?vue&type=style&index=0&id=15d96b2d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15d96b2d"]])

export default __exports__